import React, { useState } from "react"
import { defaultLang } from "../utils/default-options"

const LocaleContext = React.createContext(defaultLang)

const LocaleProvider = ({
  children,
  pageContext: { locale = defaultLang, localePath, localeData },
  location: { pathname }
}) => {

  const [message,setMessage] = useState(localeData);

  const localeDir = `/${localePath}`;
  const index = pathname.indexOf(localeDir);

  const originalPath = pathname.substring(index+localeDir.length);

  return(<LocaleContext.Provider value={{
    locale:locale, 
    message:message, 
    setMessage:setMessage,
    originalPath: originalPath
  }}>
    {children}
  </LocaleContext.Provider>);

}

export { LocaleContext, LocaleProvider }
